import { del, get, post } from "helpers/api_helper"
import { all, call, put, takeEvery } from "redux-saga/effects"
import { getFormDataFromJSON, showToast } from "utils"
import {
  createCategoryFailed,
  createCategorySuccess,
  deleteCategoryFailed,
  deleteCategorySuccess,
  editCategoryFailed,
  editCategorySuccess,
  getCategoriesFailed,
  getCategoriesSuccess,
  getCategoryFailed,
  getCategorySuccess,
  hideDeleteCategoryModal,
  hideEditCategoryModal,
  openCategoryErrorModal,
  updateCategoryOrderFailed,
  updateCategoryOrderSuccess,
  updateMultipleCategoriesOrderFailed,
  updateMultipleCategoriesOrderSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  EDIT_CATEGORY,
  GET_CATEGORIES,
  GET_CATEGORY,
  UPDATE_CATEGORY_ORDER,
  UPDATE_MULTIPLE_CATEGORIES_ORDER,
} from "./actionTypes"

function* getCategories({ payload: params }) {
  try {
    const response = yield get(url.GET_CATEGORIES_URL, params)
    yield put(getCategoriesSuccess(response))
  } catch (error) {
    yield put(getCategoriesFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateCategoryOrder({ payload: { params } }) {
  try {
    const { id, ...rest } = params
    yield post(`${url.GET_CATEGORIES_URL}/${id}`, getFormDataFromJSON(rest))
    yield put(updateCategoryOrderSuccess(params))
  } catch (error) {
    yield put(updateCategoryOrderFailed(error))
    showToast("error", error, "Error")
  }
}

function* editCategory({ payload: { categoryId, data } }) {
  try {
    yield post(
      `${url.GET_CATEGORIES_URL}/${categoryId}`,
      getFormDataFromJSON(data)
    )
    yield put(editCategorySuccess(categoryId, data))
    yield put(hideEditCategoryModal())
    showToast("success", "Category updated!", "Success")
  } catch ({ response }) {
    yield put(editCategoryFailed(response))
    showToast("error", response?.data?.error?.name || "Error", "Error")
    // yield put(openCategoryErrorModal())
  }
}

const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

function* deleteCategory({ payload: params }) {
  try {
    yield del(`${url.GET_CATEGORIES_URL}/${params?.categoryId}`)
    yield put(deleteCategorySuccess())
    if (params?.callback) {
      yield call(wait, 1000)
      params.callback()
    }
    yield put(hideDeleteCategoryModal())
    showToast("success", "Category deleted!", "Success")
  } catch (error) {
    yield put(deleteCategoryFailed(error))
    yield put(hideDeleteCategoryModal())
    showToast("error", error, "Error")
  }
}

function* createCategory({ payload: params }) {
  try {
    const response = yield post(
      url.GET_CATEGORIES_URL,
      getFormDataFromJSON(params?.values)
    )
    yield put(createCategorySuccess(response))
    if (params?.callback) {
      params.callback()
    }
    showToast("success", "Category created!", "Success")
  } catch ({ response }) {
    yield put(createCategoryFailed(response))
    showToast("error", response?.data?.error?.name || "Error", "Error")
    // yield put(openCategoryErrorModal())
  }
}

function* getCategory({ payload: params }) {
  try {
    const response = yield get(`${url.GET_CATEGORIES_URL}/${params.categoryId}`)
    yield put(getCategorySuccess(response))
  } catch (error) {
    yield put(getCategoryFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateMultipleCategoriesOrder({ payload: params }) {
  try {
    yield all(
      params?.map(category => {
        const { id, ...rest } = category
        return call(
          post,
          `${url.GET_CATEGORIES_URL}/${id}`,
          getFormDataFromJSON(rest)
        )
      })
    )
    yield put(updateMultipleCategoriesOrderSuccess())
  } catch (error) {
    yield put(updateMultipleCategoriesOrderFailed(error))
    showToast("error", error, "Error")
  }
}

function* categoriesSaga() {
  yield takeEvery(GET_CATEGORIES, getCategories)
  yield takeEvery(UPDATE_CATEGORY_ORDER, updateCategoryOrder)
  yield takeEvery(EDIT_CATEGORY, editCategory)
  yield takeEvery(DELETE_CATEGORY, deleteCategory)
  yield takeEvery(CREATE_CATEGORY, createCategory)
  yield takeEvery(GET_CATEGORY, getCategory)
  yield takeEvery(
    UPDATE_MULTIPLE_CATEGORIES_ORDER,
    updateMultipleCategoriesOrder
  )
}

export default categoriesSaga
